import type { GetOrderDetailResponse } from '~/types/apis/v2/GetOrderDetail'

export type OrderStateV2 = {
  orderDetail: GetOrderDetailResponse['data'] | null
  orderId: string | null
}
export const useOrderStoreV2 = defineStore('orderV2', {
  state: (): OrderStateV2 => ({ orderDetail: null, orderId: null }),
  actions: {
    updateOrderDetail(nextState: OrderStateV2['orderDetail']) {
      this.orderDetail = nextState
      this.orderId = nextState?.id || null
    },
    updateOrderId(nextState: OrderStateV2['orderId']) {
      this.orderId = nextState
    }
  },

  persist: true
})
